import { FileTypeEnum } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'
import { BrowserUtil, RouterUtil, WeappUtil } from 'kuaidong-lib'

const Index = () => import('../activity/202402/work-contest/index.vue')
const NameList = () => import('../activity/202402/work-contest/NameList.vue')
const ContestUpload = () => import('../activity/202402/work-contest/UploadWork.vue')
const MyHomework = () => import('../activity/202402/work-contest/MyWork.vue')

export const indexRoute: RouteConfig = {
  path: '/homework-contest-2024-home',
  name: 'homework_contest_2024_home',
  component: Index,
  meta: {
    title: '作业大赛',
  },
}

export const nameListRoute: RouteConfig = {
  path: '/homework-contest-name-list',
  name: 'homework_contest_name_list',
  component: NameList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业大赛',
  },
}

export const contestUploadRoute: RouteConfig = {
  path: '/homework-contest-upload',
  name: 'homework_contest_upload',
  component: ContestUpload,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '上传参赛',
  },
}

export const myContestRoute: RouteConfig = {
  path: '/homework-contest-my-info',
  name: 'homework_contest_my_info',
  component: MyHomework,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的参赛作品',
  },
}

export default [indexRoute, contestUploadRoute, nameListRoute, myContestRoute]

export function navigateToContestHome(router: VueRouter) {
  router.push({ name: indexRoute.name })
}

export function navigateToContestUpload(router: VueRouter) {
  router.push({ name: contestUploadRoute.name })
}

export function navigateToMyContestInfo(router: VueRouter) {
  router.push({ name: myContestRoute.name })
}

export function navigateToNameList(router: VueRouter) {
  router.push({ name: nameListRoute.name })
}

export function navigateToContestUploadMyHomework(router: VueRouter, url: string, fromWeapp = false) {
  if (BrowserUtil.isWeapp()) {
    WeappUtil.navigateToContestUploadHomework(
      FileTypeEnum.All,
      RouterUtil.buildUrlFromRoute(contestUploadRoute, { url }, router),
      fromWeapp,
      'homework-contest-2024'
    )
  } else {
    router.push({
      name: contestUploadRoute.name,
      query: { url },
    })
  }
}

export function redirectToContestUploadMyHomework(router: VueRouter, url: string, fromWeapp = false) {
  console.log(url)
  if (BrowserUtil.isWeapp()) {
    WeappUtil.navigateToContestUploadHomework(
      FileTypeEnum.All,
      RouterUtil.buildUrlFromRoute(contestUploadRoute, { url }, router),
      fromWeapp,
      'homework-contest-2024'
    )
    router.go(-1)
  } else {
    router.replace({
      name: contestUploadRoute.name,
      query: { url },
    })
  }
}
